import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import "../../../assets/styles/scheduledChanges.scss";

const ScheduledChangeDetailButtons = ({
  onEdit,
  onDelete,
  isDeleting = false,
  isEditDisabled = false,
  onApprove,
  onReject,
  isApproving = false,
  isRejecting = false,
}) => {
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount() || accounts?.[0];
  const claims = activeAccount?.idTokenClaims || {};
  const rolesRaw = claims.roles || claims.role || claims.groups;
  const roles = Array.isArray(rolesRaw) ? rolesRaw : rolesRaw ? [rolesRaw] : [];
  const isSuperUser = roles.includes("ROLE_SUPERUSER");
  const editButton = (
    <Button
      type="button"
      variant="outline-secondary"
      className="sc-btn sc-btn-edit sc-btn-iconOnly"
      aria-label="Edytuj"
      title={isEditDisabled ? undefined : "Edytuj"}
      onClick={onEdit}
      disabled={isEditDisabled}
      style={isEditDisabled ? { pointerEvents: "none" } : undefined}
    >
      <span className="sc-btn-icon" aria-hidden="true">
        <i className="bi bi-pencil" />
      </span>
      <span className="sc-btn-label">Edytuj</span>
    </Button>
  );

  return (
    <div className="sc-buttons sc-detail-buttons">
      {isSuperUser && !isEditDisabled && (
        <Button
          className="sc-btn sc-btn-accept sc-btn-iconOnly"
          variant="outline-success"
          aria-label="Akceptuj"
          title="Akceptuj"
          disabled={isApproving}
          onClick={() => {
            if (typeof onApprove === "function") onApprove();
          }}
        >
          <span className="sc-btn-icon" aria-hidden="true">
            <i className="bi bi-check-lg" />
          </span>
          <span className="sc-btn-label">Akceptuj</span>
        </Button>
      )}

      {isSuperUser && !isEditDisabled && (
        <Button
          className="sc-btn sc-btn-reject sc-btn-iconOnly"
          variant="outline-danger"
          aria-label="Odrzuć"
          title="Odrzuć"
          disabled={isRejecting}
          onClick={() => {
            if (typeof onReject === "function") onReject();
          }}
        >
          <span className="sc-btn-icon" aria-hidden="true">
            <i className="bi bi-x-lg" />
          </span>
          <span className="sc-btn-label">Odrzuć</span>
        </Button>
      )}

      {isEditDisabled ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="edit-disabled-tooltip">
              Edycja obecnie niedostępna
            </Tooltip>
          }
        >
          <span className="d-inline-block">{editButton}</span>
        </OverlayTrigger>
      ) : (
        editButton
      )}

      <Button
        type="button"
        variant="outline-danger"
        className="sc-btn sc-btn-delete sc-btn-iconOnly"
        aria-label="Usuń"
        title="Usuń"
        onClick={onDelete}
        disabled={isDeleting}
      >
        <span className="sc-btn-icon" aria-hidden="true">
          <i className="bi bi-trash" />
        </span>
        <span className="sc-btn-label">Usuń</span>
      </Button>
    </div>
  );
};

export default ScheduledChangeDetailButtons;
